export class TradeGroupFilter {
    public IncludeInactive?: boolean;
}

export default TradeGroupFilter;